import { UserEditForm } from "../../organisms/form/UserEditForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useUserEdit } from "./hook";

export const UserEditPage: React.FC = () => {
  const {
    canEditGroup,
    user,
    clients,
    groups,
    systems,
    handleCancel,
    handleEditUser,
  } = useUserEdit();

  return (
    <MainTemplate title="アカウント編集">
      {user && (
        <UserEditForm
          canEditGroup={canEditGroup}
          user={user}
          clients={clients ?? []}
          systems={systems}
          groups={groups ?? []}
          onCancel={handleCancel}
          handleSubmit={handleEditUser}
        />
      )}
    </MainTemplate>
  );
};
